export default __webpack_public_path__ + "static/media/OLIVE-AVAX.dc2befe7.png";